// extracted by mini-css-extract-plugin
module.exports = {"logoLP":"Logo_logoLP__2Wa5w","logoFAMS":"Logo_logoFAMS__3gFiF","topBar":"Logo_topBar__SoLt2"};